(() => {
  const DESKTOP = 990;
  const isDesktop = () => window.innerWidth >= DESKTOP;

  Promise.all([
    customElements.whenDefined('cart-notification'),
    customElements.whenDefined('cart-drawer'),
    customElements.whenDefined('product-form'),
  ]).then(() => {
    const notification = document.querySelector('cart-notification');
    const drawer = document.querySelector('cart-drawer');
    if (!notification || !drawer) return;

    // Patch this.cart on all existing ProductForm instances so the correct
    // component is used for both section fetching and rendering
    const patchForm = (pf) => {
      if (pf.dataset.decantlabCartRouterPatched === 'true') return;
      pf.dataset.decantlabCartRouterPatched = 'true';

      Object.defineProperty(pf, 'cart', {
        get() { return isDesktop() ? drawer : notification; },
        configurable: true,
      });
    };

    document.querySelectorAll('product-form').forEach(patchForm);

    // Facets replace the collection grid, so patch product forms inserted later too.
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches('product-form')) patchForm(node);
          node.querySelectorAll?.('product-form').forEach(patchForm);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Cart icon: open drawer on desktop, fall through to link on mobile
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      const replacement = cartIcon.cloneNode(true);
      cartIcon.parentNode.replaceChild(replacement, cartIcon);
      replacement.addEventListener('click', (event) => {
        if (isDesktop()) {
          event.preventDefault();
          drawer.open(replacement);
        }
      });
    }
  });
})();
